import { render, staticRenderFns } from "./RirsTableBodyRow.vue?vue&type=template&id=0b5dd997&scoped=true"
import script from "./RirsTableBodyRow.vue?vue&type=script&lang=js"
export * from "./RirsTableBodyRow.vue?vue&type=script&lang=js"
import style0 from "./RirsTableBodyRow.vue?vue&type=style&index=0&id=0b5dd997&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5dd997",
  null
  
)

export default component.exports